import i18n from '../i18n'
import { tonStringFromPounds, formatMoney } from '../utils/NumericMutations'
import { SETTING_KEYS } from '@/utils/UserSettings.js'
import { DataTableColumn, ColumnSet } from '@/model/DataTableColumn'
import { DeckContentType } from '@/utils/Enumerations'

export function deckHeaders () {
  const columns = [
    new DataTableColumn({
      id: 0,
      sortable: false,
      text: i18n.t('status'),
      value: 'status',
      align: 'center',
      hidable: false
    }),
    new DataTableColumn({
      id: 1,
      sortable: true,
      text: i18n.t('name'),
      value: 'name',
      align: 'left',
      hidable: false
    }),
    new DataTableColumn({
      id: 7,
      sortable: true,
      text: i18n.t('contentType'),
      value: 'contentType',
      align: 'center',
      hidable: false,
      format: c => DeckContentType.fromInt(c)
    }),
    new DataTableColumn({
      id: 8,
      sortable: true,
      text: i18n.t('species'),
      value: 'species',
      align: 'left',
      hidable: true
    }),
    new DataTableColumn({
      id: 2,
      sortable: true,
      text: i18n.t('loadsOnDeck'),
      value: 'loadsOnDeck',
      align: 'right',
      hidable: true
    }),
    new DataTableColumn({
      id: 9,
      sortable: true,
      text: i18n.t('onDeckMbf'),
      value: 'onDeckMbf',
      align: 'right',
      format: tonStringFromPounds,
      hidable: false
    }),
    new DataTableColumn({
      id: 3,
      sortable: true,
      text: i18n.t('onDeckTons'),
      value: 'onDeckTons',
      align: 'right',
      format: tonStringFromPounds,
      hidable: false
    }),
    new DataTableColumn({
      id: 4,
      sortable: true,
      text: i18n.t('value'),
      value: 'value',
      align: 'right',
      format: formatMoney,
      hidable: true
    }),
    new DataTableColumn({
      id: 5,
      sortable: true,
      text: i18n.t('modifiedAt'),
      value: 'openClose',
      hidable: false
    }),
    new DataTableColumn({
      id: 6,
      sortable: false,
      text: i18n.t('actions'),
      value: 'actions',
      align: 'center',
      hidable: false
    })
  ]

  return new ColumnSet({
    columns,
    setName: 'DeckHeaders',
    userSettingKey: SETTING_KEYS.DECK_GRID_HIDDEN_COLUMNS
  })
}

export function deckAdjustmentHeaders (isBoardFoot = false) {
  return [
    {
      sortable: true,
      text: i18n.t('createdBy'),
      value: 'createdBy',
      align: 'center'
    },
    {
      sortable: true,
      text: i18n.t('createdAt'),
      value: 'createdAt',
      align: 'center'
    },
    {
      sortable: true,
      text: i18n.t('onDeckAt'),
      value: 'onDeckAt',
      align: 'right'
    },
    {
      sortable: true,
      text: i18n.t('valueAt'),
      value: 'valueAt',
      align: 'right'
    },
    {
      sortable: true,
      text: i18n.t('averageValuePerUnitAt'),
      value: 'averageValuePerUnitAt',
      align: 'right'
    },
    {
      sortable: true,
      text: i18n.t(isBoardFoot ? 'adjustmentMBF' : 'adjustmentTons'),
      value: 'adjustmentTons',
      align: 'right'
    },
    {
      sortable: true,
      text: i18n.t('adjustmentValue'),
      value: 'adjustmentValue',
      align: 'right'
    },
    {
      sortable: true,
      text: i18n.t('onDeck'),
      value: 'onDeck',
      align: 'right'
    },
    {
      sortable: true,
      text: i18n.t('value'),
      value: 'value',
      align: 'right'
    },
    {
      text: i18n.t('actions'),
      value: 'actions',
      align: 'center'
    }
  ]
}
